/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable max-classes-per-file */
import { IsOptional, ValidateNested } from 'class-validator';
import { ClassConstructor, Type } from 'class-transformer';
import { httpClient, IsOptionalString } from '../../../http-client';
import { AxiosRequestConfig } from 'axios';

export namespace authVerifyDTO {
  export interface Req {
    token: string;
  }

  
  export class Res {
    @IsOptionalString()
    data?: string;
  }

  export class Response {
    @IsOptional()
    @ValidateNested()
    @Type(() => Res)
    res?: Res | null;
  }
}

export const authVerify = (
  reqData: authVerifyDTO.Req,
  config = {} as AxiosRequestConfig & {
    dto: ClassConstructor<authVerifyDTO.Res>;
  }
) => {
  config.dto = authVerifyDTO.Res;
  return httpClient.post<authVerifyDTO.Res>(`/register/activation/${reqData.token}`, reqData, config);
};
